import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { bomListQuery } from "@/features/production/api";
import { validateVersionSearch, type VersionSearch } from "@/features/production/search";
import { VersionListPage } from "@/features/production/VersionListPage";
import { versionListColumns } from "@patronix/domain/list";
import { viewQuery } from "@/lib/listView";

export const Route = createFileRoute("/_app/engineering/boms")({
  validateSearch: validateVersionSearch,
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q, f: search.f, s: search.s }),
  loader: ({ context, deps }) => context.queryClient.ensureInfiniteQueryData(bomListQuery({ status: deps.status, q: deps.q, ...viewQuery(versionListColumns, deps) })),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<VersionSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <VersionListPage kind="bom" search={search} setSearch={setSearch} />;
}
